export default {
  common: {
    save: 'Salvar',
    cancel: 'Cancelar',
    close: 'Fechar',
    delete: 'Excluir',
    edit: 'Editar',
    view: 'Visualizar',
    create: 'Novo',
    new: 'Novo',
    search: 'Buscar',
    searching: 'Buscando...',
    saving: 'Salvando...',
    deleting: 'Excluindo...',
    loading: 'Carregando...',
    clearFilters: 'Limpar Filtros',
    previous: 'Anterior',
    next: 'Proxima',
    page: 'Pagina',
    noResults: 'Nenhum registro encontrado.',
    confirmDelete: 'Confirmar Exclusao',
    confirmDeleteMsg: 'Tem certeza que deseja excluir',
    success: 'Sucesso',
    error: 'Erro',
    warning: 'Aviso',
    validation: 'Validacao',
    required: 'Campo obrigatorio',
    exportCsv: 'Exportar CSV',
    exportPdf: 'Exportar PDF',
    exportSuccess: 'Exportacao concluida!',
    exportError: 'Erro ao exportar',
    actions: 'Acoes',
    status: 'Status',
    active: 'Ativo',
    inactive: 'Inativo',
    yes: 'Sim',
    no: 'Nao',
    all: 'Todos',
    id: 'Codigo',
    name: 'Nome',
    description: 'Descricao',
    date: 'Data',
    value: 'Valor',
    total: 'Total',
    details: 'Detalhes',
    information: 'Informacoes',
    confirm: 'Confirmar',
    back: 'Voltar',
    refresh: 'Atualizar',
    select: 'Selecione',
    open: 'Aberto',
    closed: 'Fechado',
    generating: 'Gerando...',
    calculating: 'Calculando...',
    processing: 'Processando...',
    sending: 'Enviando...',
  },

  validation: {
    required: 'Campo obrigatorio',
    email: 'Email invalido',
    minLength: 'Minimo de {min} caracteres',
    maxLength: 'Maximo de {max} caracteres',
    positive: 'Valor deve ser positivo',
    invalidCpf: 'CPF invalido',
    invalidCnpj: 'CNPJ invalido',
    passwordsDontMatch: 'As senhas nao coincidem',
    allFieldsRequired: 'Todos os campos sao obrigatorios',
  },

  status: {
    PENDENTE: 'Pendente',
    CONCLUIDA: 'Concluida',
    CANCELADA: 'Cancelada',
    PAGO: 'Pago',
    PAGA: 'Paga',
    VENCIDO: 'Vencido',
    VENCIDA: 'Vencida',
    ABERTO: 'Aberto',
    FECHADO: 'Fechado',
    EM_TRANSITO: 'Em Transito',
    EM_ANDAMENTO: 'Em Andamento',
    ATIVO: 'Ativo',
    INATIVO: 'Inativo',
    PROCESSANDO: 'Processando',
    ERRO: 'Erro',
    CONVERTIDO: 'Convertido',
    EXPIRADO: 'Expirado',
    APROVADO: 'Aprovado',
    REJEITADO: 'Rejeitado',
    NORMAL: 'Normal',
    ALERTA: 'Alerta',
    AGENDADO: 'Agendado',
    AGENDADA: 'Agendada',
    CONCLUIDO: 'Concluido',
    REALIZADA: 'Realizada',
    CONFIRMADO: 'Confirmado',
    CANCELADO: 'Cancelado',
    LIVRE: 'Livre',
    OCUPADA: 'Ocupada',
    RESERVADA: 'Reservada',
    ABERTA: 'Aberta',
    AGUARDANDO_PECAS: 'Aguardando Pecas',
    ENTREGUE: 'Entregue',
  },

  paymentMethod: {
    DINHEIRO: 'Dinheiro',
    CARTAO_CREDITO: 'Cartao de Credito',
    CARTAO_DEBITO: 'Cartao de Debito',
    CHEQUE: 'Cheque',
    PIX: 'PIX',
    BOLETO: 'Boleto',
  },

  nav: {
    dashboard: 'Dashboard',
    caixa: 'Caixa',
    vendas: 'Vendas',
    orcamentos: 'Orcamentos',
    clientes: 'Clientes',
    produtos: 'Produtos',
    categorias: 'Categorias',
    estoque: 'Estoque',
    inventario: 'Inventario',
    fornecedores: 'Fornecedores',
    trocas: 'Trocas',
    promocoes: 'Promocoes',
    contasReceber: 'Contas a Receber',
    contasPagar: 'Contas a Pagar',
    entregas: 'Entregas',
    etiquetas: 'Etiquetas',
    relatorios: 'Relatorios',
    importacao: 'Importacao',
    notificacoes: 'Notificacoes',
    usuarios: 'Usuarios',
    perfis: 'Perfis',
    comissoes: 'Comissoes',
    configuracoes: 'Configuracoes',
    auditoria: 'Auditoria',
    loja: 'Loja',
    administracao: 'Administracao',
    meuPerfil: 'Meu Perfil',
    permissoes: 'Permissoes',
    banhoTosa: 'Banho e Tosa',
    racoes: 'Racoes e Acessorios',
    cardapio: 'Cardapio',
    mesas: 'Mesas',
    prontuarios: 'Prontuarios',
    consultas: 'Consultas',
    fidelidade: 'Fidelidade',
    servicos: 'Servicos',
    profissionais: 'Profissionais',
    agenda: 'Agenda',
    funcionarios: 'Funcionarios',
    agendamentos: 'Agendamentos',
    ordensServico: 'Ordens de Servico',
  },

  login: {
    welcome: 'Bem-vindo ao SisGel',
    subtitle: 'Sistema de Gerenciamento para a sua loja',
    formTitle: 'Acesso ao Sistema',
    formSubtitle: 'Digite suas credenciais para continuar',
    username: 'Nome de usuario',
    password: 'Senha',
    enter: 'Entrar no Sistema',
    entering: 'Entrando...',
    usernameRequired: 'Nome de usuario e obrigatorio',
    usernameMinLength: 'Nome de usuario deve ter pelo menos 3 caracteres',
    passwordRequired: 'Senha e obrigatoria',
    passwordMinLength: 'Senha deve ter pelo menos 4 caracteres',
    loginSuccess: 'Login realizado com sucesso!',
    loginError: 'Erro ao realizar login',
    help: 'Em caso de problemas, entre em contato com o administrador',
    footer: 'SisGel - Sistema de Gerenciamento de Loja',
  },

  meuPerfil: {
    title: 'Meu Perfil',
    userInfo: 'Informacoes do Usuario',
    editProfile: 'Editar Perfil',
    changePassword: 'Alterar Senha',
    nome: 'Nome',
    email: 'Email',
    perfil: 'Perfil',
    loja: 'Loja',
    currentPassword: 'Senha Atual',
    newPassword: 'Nova Senha',
    confirmPassword: 'Confirmar Nova Senha',
    saveProfile: 'Salvar Perfil',
    nameEmailRequired: 'Nome e email sao obrigatorios',
    passwordFieldsRequired: 'Todos os campos de senha sao obrigatorios',
    profileUpdated: 'Perfil atualizado com sucesso!',
    passwordChanged: 'Senha alterada com sucesso!',
    profileUpdateError: 'Erro ao atualizar perfil',
    passwordChangeError: 'Erro ao alterar senha',
    nomePlaceholder: 'Seu nome',
    emailPlaceholder: 'Seu email',
    nomeLoja: 'Nome da Loja',
    nomelLojaPlaceholder: 'Nome da sua loja',
    changingPassword: 'Alterando...',
  },

  fornecedor: {
    title: 'Controle de Fornecedores',
    new: 'Novo Fornecedor',
    edit: 'Editar Fornecedor',
    details: 'Detalhes do Fornecedor',
    razaoSocial: 'Razao Social',
    nomeFantasia: 'Nome Fantasia',
    cnpj: 'CNPJ',
    telefone: 'Telefone',
    email: 'Email',
    endereco: 'Endereco',
    contato: 'Contato',
    created: 'Fornecedor criado com sucesso!',
    updated: 'Fornecedor atualizado com sucesso!',
    deleted: 'Fornecedor excluido com sucesso!',
    createError: 'Erro ao criar fornecedor',
    updateError: 'Erro ao atualizar fornecedor',
    deleteError: 'Erro ao excluir fornecedor',
    notFound: 'Nenhum fornecedor encontrado.',
    requiredRazaoSocial: 'Razao Social e obrigatoria',
  },

  cliente: {
    title: 'Controle de Clientes',
    new: 'Novo Cliente',
    edit: 'Editar Cliente',
    details: 'Detalhes do Cliente',
    nome: 'Nome',
    telefone: 'Telefone',
    endereco: 'Endereco',
    dataCriacao: 'Data de Criacao',
    created: 'Cliente criado com sucesso!',
    updated: 'Cliente atualizado com sucesso!',
    deleted: 'Cliente excluido com sucesso!',
    notFound: 'Nenhum cliente encontrado.',
    nameRequired: 'Nome e obrigatorio',
    informacoes: 'Informacoes do Cliente',
    nomePlaceholder: 'Nome do Cliente',
    nomeCompleto: 'Nome completo do cliente',
    enderecoCompleto: 'Endereco completo',
  },

  produto: {
    title: 'Controle de Produtos',
    new: 'Novo Produto',
    edit: 'Editar Produto',
    details: 'Detalhes do Produto',
    nome: 'Nome',
    descricao: 'Descricao',
    codigoBarras: 'Codigo de Barras',
    precoVenda: 'Preco Venda',
    precoCusto: 'Preco Custo',
    unidadeMedida: 'Unidade de Medida',
    categoria: 'Categoria',
    informacoes: 'Informacoes do Produto',
    nomePlaceholder: 'Nome do Produto',
    descricaoPlaceholder: 'Descricao do Produto',
    margemLucro: 'Margem de Lucro (%)',
    margem: 'Margem',
    valores: 'Valores',
    selecioneUnidade: 'Selecione uma unidade',
    selecioneCategoria: 'Selecione uma categoria',
    calculationHint: 'Digite no preco de venda para calcular a margem, ou na margem para calcular o preco de venda',
    produtoAtivo: 'Produto Ativo',
    dataCadastro: 'Data de Cadastro',
    activate: 'Ativar',
    deactivate: 'Desativar',
    created: 'Produto criado com sucesso!',
    updated: 'Produto atualizado com sucesso!',
    deleted: 'Produto excluido com sucesso!',
    notFound: 'Nenhum produto encontrado.',
  },

  categoria: {
    title: 'Controle de Categorias',
    new: 'Nova Categoria',
    edit: 'Editar Categoria',
    details: 'Detalhes da Categoria',
    nome: 'Nome',
    descricao: 'Descricao',
    codigoInterno: 'Codigo Interno',
    informacoes: 'Informacoes da Categoria',
    nomePlaceholder: 'Nome da Categoria',
    codigoInternoPlaceholder: 'Codigo interno (opcional)',
    descricaoPlaceholder: 'Digite uma descricao para a categoria',
    categoriaAtiva: 'Categoria Ativa',
    categoriaInativa: 'Categoria Inativa',
    dataCriacao: 'Data Criacao',
    activate: 'Ativar',
    deactivate: 'Desativar',
    created: 'Categoria criada com sucesso!',
    updated: 'Categoria atualizada com sucesso!',
    deleted: 'Categoria excluida com sucesso!',
    notFound: 'Nenhuma categoria encontrada.',
  },

  estoque: {
    title: 'Controle de Estoque',
    new: 'Novo Estoque',
    edit: 'Editar Estoque',
    details: 'Detalhes do Estoque',
    produto: 'Produto',
    quantidade: 'Quantidade',
    quantidadeMinima: 'Quantidade Minima',
    localizacao: 'Localizacao',
    ultimaEntrada: 'Ultima Entrada',
    ultimaSaida: 'Ultima Saida',
    informacoes: 'Informacoes do Estoque',
    historico: 'Historico',
    todasLocalizacoes: 'Todas as Localizacoes',
    nomeProduto: 'Nome do Produto',
    selecioneProduto: 'Selecione um produto',
    selecioneLocalizacao: 'Selecione a localizacao',
    dataAtualizacao: 'Data Atualizacao',
    alerta: 'Alerta',
    normal: 'Normal',
    created: 'Estoque criado com sucesso!',
    updated: 'Estoque atualizado com sucesso!',
    deleted: 'Estoque excluido com sucesso!',
    notFound: 'Nenhum estoque encontrado.',
  },

  venda: {
    title: 'Vendas',
    dataHora: 'Data/Hora',
    responsavel: 'Responsavel',
    tipo: 'Tipo',
    totalBruto: 'Total Bruto',
    desconto: 'Desconto',
    totalLiquido: 'Total Liquido',
    notFound: 'Nenhuma venda encontrada.',
    allStatus: 'Todos os Status',
    concluidas: 'Concluidas',
    pendentes: 'Pendentes',
    canceladas: 'Canceladas',
    allCaixas: 'Todos os Caixas',
    vendas: 'venda(s)',
    caixa: 'Caixa',
  },

  caixa: {
    title: 'Caixa',
    statusCaixa: 'Status do Caixa',
    saldoInicial: 'Saldo Inicial',
    totalVendido: 'Total Vendido',
    saldoFinal: 'Saldo Final',
    vendasHoje: 'Vendas Hoje',
    abrirCaixa: 'ABRIR CAIXA',
    fecharCaixa: 'FECHAR CAIXA',
    novaVenda: 'NOVA VENDA',
    vendasDoCaixa: 'Vendas do Caixa',
    caixaNaoAberto: 'Caixa nao aberto',
    carregandoVendas: 'Carregando vendas...',
    nenhumaVenda: 'Nenhuma venda encontrada',
    todas: 'Todas',
    apenasGerentesFecham: 'Apenas gerentes podem fechar o caixa',
    detalhesVenda: 'Detalhes da Venda',
    informacoesVenda: 'Informacoes da Venda',
    data: 'Data',
    hora: 'Hora',
    responsavel: 'Responsavel',
    tipoVenda: 'Tipo Venda',
    cliente: 'Cliente',
    naoInformado: 'Nao informado',
    observacoes: 'Observacoes',
    nenhuma: 'Nenhuma',
    itensVenda: 'Itens da Venda',
    produto: 'Produto',
    qtd: 'Qtd',
    precoUnit: 'Preco Unit.',
    nenhumItem: 'Nenhum item encontrado para esta venda',
    informacoesPagamento: 'Informacoes de Pagamento',
    formaPagamento: 'Forma de Pagamento',
    valorPago: 'Valor Pago',
    dataPagamento: 'Data Pagamento',
    numParcelas: 'N. Parcelas',
    pagamentoNaoEncontrado: 'Informacoes de pagamento nao encontradas',
    pagamento: 'Pagamento',
    parcelas: 'Parcelas',
    totalBruto: 'Total Bruto',
    desconto: 'Desconto',
    totalLiquido: 'Total Liquido',
    carregandoDetalhes: 'Carregando detalhes...',
    salvarConcluir: 'Salvar e Concluir',
    concluirVenda: 'Concluir Venda',
    cancelando: 'Cancelando...',
    cancelarVenda: 'Cancelar Venda',
    entendi: 'Entendi',
    fecharCaixaTitle: 'Fechar Caixa',
    resumoCaixa: 'Resumo do Caixa',
    operador: 'Operador',
    abertoEm: 'Aberto em',
    fechamento: 'Fechamento',
    valorEmCaixa: 'Valor em caixa (contagem)',
    informeValorContado: 'Informe o valor contado no caixa',
    observacoesFechamento: 'Observacoes do fechamento',
    observacoesFechamentoPlaceholder: 'Observacoes sobre o fechamento...',
    saldoEsperado: 'Saldo Esperado',
    valorContado: 'Valor Contado',
    diferenca: 'Diferenca',
    fechandoCaixa: 'Fechando...',
    confirmarFechamento: 'Confirmar Fechamento',
    iniciarVenda: 'Iniciar Venda',
    clienteOpcional: 'Cliente (opcional)',
    semCliente: 'Sem cliente (venda anonima)',
    novoCliente: 'Novo Cliente',
    nomeCliente: 'Nome do cliente',
    telefone: 'Telefone',
    telefonePlaceholder: '(00) 00000-0000',
    cadastrarCliente: 'Cadastrar e Selecionar',
    totalDaVenda: 'Total da Venda',
    quantidadeItens: 'Quantidade de Itens',
    selecioneFormaPagamento: 'Selecione a forma de pagamento',
    valorRecebido: 'Valor Recebido',
    troco: 'Troco',
    valorInsuficiente: 'Valor insuficiente! Faltam',
    valorPorParcela: 'Valor por parcela',
    parcelasGeradas: 'Parcelas Geradas',
    salvarAberta: 'Salvar Aberta',
    finalizarVenda: 'Finalizar Venda',
    produtoNaoEncontrado: 'Produto nao encontrado',
    quantidade: 'Quantidade',
    precoUnitario: 'Preco Unitario',
    subtotal: 'Subtotal',
    removerItem: 'Remover item',
    parcela: 'Parcela',
    vendaSemItens: 'Venda sem itens',
    adicioneItem: 'Adicione pelo menos um item para concluir a venda.',
    pagamentoObrigatorio: 'Pagamento obrigatorio',
    selecionePagamento: 'Selecione a forma de pagamento para concluir a venda.',
    valorInvalido: 'Valor invalido',
    informeValorPago: 'Informe o valor pago para concluir a venda.',
    confirmaConcluirVenda: 'Tem certeza que deseja concluir esta venda?',
    vendaConcluidaCancelar: 'Esta venda ja foi concluida. Tem certeza que deseja cancelar?',
    confirmaCancelarVenda: 'Tem certeza que deseja cancelar esta venda?',
    vendaConcluidaSucesso: 'Venda concluida com sucesso!',
    erroConcluirVenda: 'Erro ao concluir venda',
    vendaCanceladaSucesso: 'Venda cancelada com sucesso!',
    erroCancelarVenda: 'Erro ao cancelar venda',
    caixaFechadoSucesso: 'Caixa fechado com sucesso!',
    erroFecharCaixa: 'Erro ao fechar o caixa. Tente novamente.',
    diferencaCaixa: 'Ha uma diferenca de R$ {valor} no caixa. Deseja continuar?',
    confirmaFechamento: 'Confirma o fechamento do caixa?',
  },

  contaPagar: {
    title: 'Contas a Pagar',
    new: 'Nova Conta a Pagar',
    edit: 'Editar Conta a Pagar',
    details: 'Detalhes da Conta',
    descricao: 'Descricao',
    fornecedor: 'Fornecedor',
    valor: 'Valor',
    valorPago: 'Valor Pago',
    dataEmissao: 'Data Emissao',
    dataVencimento: 'Data Vencimento',
    dataPagamento: 'Data Pagamento',
    categoria: 'Categoria',
    numeroDocumento: 'Nro Documento',
    numeroNotaFiscal: 'Nro Nota Fiscal',
    observacao: 'Observacao',
    registrarPagamento: 'Registrar Pagamento',
    total: 'Total',
    pendente: 'Pendente',
    pago: 'Pago',
    vencido: 'Vencido',
    cancelado: 'Cancelado',
    created: 'Conta criada com sucesso!',
    updated: 'Conta atualizada com sucesso!',
    deleted: 'Conta excluida com sucesso!',
    paymentRegistered: 'Pagamento registrado com sucesso!',
    notFound: 'Nenhuma conta a pagar encontrada.',
    requiredFields: 'Preencha os campos obrigatorios',
    requiredPayment: 'Informe valor e data do pagamento',
    payBtn: 'Pagar',
    allStatus: 'Todos os Status',
    allCategories: 'Todas as Categorias',
    valorDaConta: 'Valor da Conta',
    newConta: 'Nova Conta',
    infoSection: 'Informacoes da Conta',
    descPlaceholder: 'Descricao da conta',
    fornecedorPlaceholder: 'Selecione o fornecedor',
    categoriaPlaceholder: 'Selecione uma categoria',
    docPlaceholder: 'Numero do documento',
    nfPlaceholder: 'Numero da NF',
    obsPlaceholder: 'Observacoes adicionais',
    emissao: 'Emissao',
    vencimento: 'Vencimento',
    pagamento: 'Pagamento',
  },

  contasReceber: {
    title: 'Contas a Receber',
    totalPendente: 'Total Pendente',
    totalVencido: 'Total Vencido',
    aVencerHoje: 'A Vencer Hoje',
    aVencerSemana: 'A Vencer Semana',
    parcela: 'Parcela',
    vencimento: 'Vencimento',
    marcarPaga: 'Marcar como Paga',
    carregandoResumo: 'Carregando resumo...',
    notFound: 'Nenhuma parcela encontrada.',
    allStatus: 'Todos os Status',
    paga: 'Paga',
    vencida: 'Vencida',
    dataInicio: 'Data Inicio',
    dataFim: 'Data Fim',
  },

  entrega: {
    title: 'Controle de Entregas',
    new: 'Nova Entrega',
    edit: 'Editar Entrega',
    details: 'Detalhes da Entrega',
    destinatario: 'Destinatario',
    telefone: 'Telefone',
    endereco: 'Endereco',
    logradouro: 'Logradouro',
    numero: 'Numero',
    complemento: 'Complemento',
    bairro: 'Bairro',
    cidade: 'Cidade',
    uf: 'UF',
    cep: 'CEP',
    transportadora: 'Transportadora',
    codigoRastreio: 'Codigo Rastreio',
    valorFrete: 'Valor Frete',
    pesoTotal: 'Peso Total',
    previsaoEntrega: 'Previsao Entrega',
    observacao: 'Observacao',
    alterarStatus: 'Alterar Status',
    novoStatus: 'Novo Status',
    venda: 'Venda',
    cliente: 'Cliente',
    cidadeUf: 'Cidade/UF',
    previsao: 'Previsao',
    created: 'Entrega criada com sucesso!',
    updated: 'Entrega atualizada com sucesso!',
    deleted: 'Entrega excluida com sucesso!',
    statusUpdated: 'Status atualizado com sucesso!',
    notFound: 'Nenhuma entrega encontrada.',
    requiredFields: 'Preencha os campos obrigatorios (Venda, Nome, Logradouro)',
    allStatus: 'Todos os Status',
    emTransito: 'Em Transito',
    vinculo: 'Vinculo',
    selectVenda: 'Selecione a venda...',
    selectCliente: 'Selecione o cliente',
    selectTransportadora: 'Selecione a transportadora',
    nomePlaceholder: 'Nome do destinatario',
    logradouroPlaceholder: 'Rua, Avenida...',
    complementoPlaceholder: 'Apto, Bloco...',
    transporte: 'Transporte',
  },

  orcamento: {
    title: 'Orcamentos',
    new: 'Novo Orcamento',
    edit: 'Editar Orcamento',
    details: 'Detalhes do Orcamento',
    cliente: 'Cliente',
    dataCriacao: 'Data Criacao',
    validade: 'Validade',
    total: 'Total',
    converter: 'Converter',
    created: 'Orcamento criado com sucesso!',
    updated: 'Orcamento atualizado com sucesso!',
    deleted: 'Orcamento excluido com sucesso!',
    notFound: 'Nenhum orcamento encontrado.',
    allStatus: 'Todos os Status',
    allClientes: 'Todos os Clientes',
    clienteId: 'ID do Cliente',
    info: 'Informacoes do Orcamento',
    dataValidade: 'Data de Validade',
    observacao: 'Observacao',
    itens: 'Itens',
    addItem: 'Adicionar Item',
    produto: 'Produto',
    qtd: 'Qtd',
    precoUnit: 'Preco Unit.',
    desconto: 'Desconto',
    subtotal: 'Subtotal',
    totalEstimado: 'Total Estimado',
    totalLiquido: 'Total Liquido',
    totalBruto: 'Total Bruto',
    noItem: 'Nenhum item.',
    selectCliente: 'Selecione o cliente...',
    selectProduto: 'Selecione o produto...',
  },

  troca: {
    title: 'Trocas e Devolucoes',
    new: 'Nova Troca',
    details: 'Detalhes da Troca',
    vendaOriginal: 'Venda Original',
    tipo: 'Tipo',
    motivo: 'Motivo',
    valorTotal: 'Valor Total',
    data: 'Data',
    created: 'Troca criada com sucesso!',
    deleted: 'Troca excluida com sucesso!',
    notFound: 'Nenhuma troca encontrada.',
    allTipos: 'Todos os Tipos',
    allMotivos: 'Todos os Motivos',
    tipoTroca: 'Troca',
    tipoDevolucao: 'Devolucao',
    motivoDefeito: 'Defeito',
    motivoInsatisfacao: 'Insatisfacao',
    motivoErroVenda: 'Erro de Venda',
    motivoTamanho: 'Tamanho',
    motivoOutro: 'Outro',
    vendaId: 'ID Venda Original',
    info: 'Informacoes da Troca',
    selectVenda: 'Selecione a venda...',
    observacao: 'Observacao',
    obsPlaceholder: 'Observacoes sobre a troca',
    itens: 'Itens',
    addItem: 'Adicionar Item',
    produto: 'Produto',
    quantidade: 'Quantidade',
    valorUnit: 'Valor Unitario',
    subtotal: 'Subtotal',
    noItem: 'Nenhum item.',
  },

  promocao: {
    title: 'Promocoes',
    new: 'Nova Promocao',
    edit: 'Editar Promocao',
    details: 'Detalhes da Promocao',
    nome: 'Nome',
    tipoDesconto: 'Tipo Desconto',
    valor: 'Valor',
    dataInicio: 'Data Inicio',
    dataFim: 'Data Fim',
    ativa: 'Ativa',
    created: 'Promocao criada com sucesso!',
    updated: 'Promocao atualizada com sucesso!',
    deleted: 'Promocao excluida com sucesso!',
    notFound: 'Nenhuma promocao encontrada.',
    todas: 'Todas',
    ativas: 'Ativas',
    inativas: 'Inativas',
    todosTipos: 'Todos os Tipos',
    porcentagem: 'Porcentagem',
    valorFixo: 'Valor Fixo',
    informacoes: 'Informacoes da Promocao',
    nomePlaceholder: 'Nome da promocao',
    tipoPromocao: 'Tipo de Promocao',
    diaSemana: 'Dia da Semana',
    horaInicio: 'Hora Inicio',
    horaFim: 'Hora Fim',
    comboProdutosInfo: 'Os produtos do combo sao gerenciados atraves dos vinculos de produtos abaixo.',
    leveQuantidade: 'Leve (quantidade)',
    pagueQuantidade: 'Pague (quantidade)',
    precoClienteCadastrado: 'Preco Cliente Cadastrado (R$)',
    precoClienteNaoCadastrado: 'Preco Cliente Nao Cadastrado (R$)',
    valorDesconto: 'Valor Desconto',
    valorDescontoPlaceholder: 'Valor do desconto',
    descricaoPlaceholder: 'Descricao da promocao',
    vinculos: 'Vinculos',
    produtoIds: 'Produtos',
    categoriaIds: 'Categorias',
    selecioneProdutos: 'Selecione os produtos...',
    selecioneCategorias: 'Selecione as categorias...',
    salvarPromocao: 'Salvar Promocao',
    dataCriacao: 'Data Criacao',
    produtos: 'Produtos',
    categorias: 'Categorias',
    nenhumProdutoVinculado: 'Nenhum produto vinculado.',
    nenhumaCategoriaVinculada: 'Nenhuma categoria vinculada.',
    nomeeTipoObrigatorios: 'Nome e Tipo de Desconto sao obrigatorios',
  },

  inventario: {
    title: 'Inventarios',
    new: 'Novo Inventario',
    edit: 'Editar Inventario',
    details: 'Detalhes do Inventario',
    dataCriacao: 'Data Criacao',
    dataConclusao: 'Data Conclusao',
    totalItens: 'Total Itens',
    conferidos: 'Conferidos',
    divergentes: 'Divergentes',
    concluir: 'Concluir',
    observacao: 'Observacao',
    obsPlaceholder: 'Observacao do inventario',
    conferencia: 'Conferencia',
    salvarContagens: 'Salvar Contagens',
    confirmConclusao: 'Confirmar Conclusao',
    confirmConclusaoMsg: 'Tem certeza que deseja concluir o inventario',
    concluindo: 'Concluindo...',
    created: 'Inventario criado com sucesso!',
    updated: 'Inventario atualizado com sucesso!',
    deleted: 'Inventario excluido com sucesso!',
    notFound: 'Nenhum inventario encontrado.',
  },

  importacao: {
    title: 'Importacao de XML',
    importar: 'Importar XML',
    arquivoUnico: 'Arquivo Unico',
    loteArquivos: 'Lote de Arquivos',
    selecioneArquivo: 'Selecione um arquivo XML',
    selecioneMultiplos: 'Selecione multiplos arquivos XML',
    enviarXml: 'Enviar XML',
    enviarLote: 'Enviar Lote',
    usuario: 'Usuario',
    totalRegistros: 'Total Registros',
    registrosSucesso: 'Registros Sucesso',
    notFound: 'Nenhuma importacao encontrada.',
  },

  relatorio: {
    title: 'Relatorios',
    gerar: 'Gerar Relatorio',
    tipo: 'Tipo',
    dataGeracao: 'Data Geracao',
    parametros: 'Parametros do Relatorio',
    dados: 'Dados do Relatorio',
    dataInicio: 'Data Inicio',
    dataFim: 'Data Fim',
    pdf: 'PDF',
    notFound: 'Nenhum relatorio encontrado.',
    tipoVendas: 'VENDAS',
    tipoProdutos: 'PRODUTOS',
    tipoEstoque: 'ESTOQUE',
    tipoClientes: 'CLIENTES',
    tipoFinanceiro: 'FINANCEIRO',
    tipoCaixa: 'CAIXA',
  },

  etiqueta: {
    title: 'Etiquetas de Preco',
    layout: 'Layout da Etiqueta',
    buscarProduto: 'Buscar Produto',
    nomeProduto: 'Nome do produto',
    produtosSelecionados: 'Produtos Selecionados',
    preco: 'Preco',
    qtdEtiquetas: 'Qtd Etiquetas',
    nenhumSelecionado: 'Nenhum produto selecionado. Busque e adicione produtos acima.',
    gerarPdf: 'Gerar PDF',
  },

  notificacao: {
    title: 'Notificacoes',
    marcarTodasLidas: 'Marcar Todas como Lidas',
    nova: 'Nova',
    notFound: 'Nenhuma notificacao encontrada.',
  },

  usuario: {
    title: 'Controle de Usuarios',
    new: 'Novo Usuario',
    edit: 'Editar Usuario',
    details: 'Detalhes do Usuario',
    nome: 'Nome',
    email: 'Email',
    senha: 'Senha',
    ativo: 'Usuario Ativo',
    created: 'Usuario criado com sucesso!',
    updated: 'Usuario atualizado com sucesso!',
    deleted: 'Usuario excluido com sucesso!',
    perfil: 'Perfil',
    loja: 'Loja',
    informacoes: 'Informacoes do Usuario',
    nomePlaceholder: 'Nome do Usuario',
    selecionePerfil: 'Selecione um perfil',
    manterPerfil: 'Manter perfil atual',
    notFound: 'Nenhum usuario encontrado.',
  },

  perfil: {
    title: 'Controle de Perfis',
    new: 'Novo Perfil',
    edit: 'Editar Perfil',
    details: 'Detalhes do Perfil',
    nome: 'Nome',
    descricao: 'Descricao',
    nivelAcesso: 'Nivel de Acesso',
    created: 'Perfil criado com sucesso!',
    updated: 'Perfil atualizado com sucesso!',
    deleted: 'Perfil excluido com sucesso!',
    informacoes: 'Informacoes do Perfil',
    nomePlaceholder: 'Nome do Perfil',
    descricaoPlaceholder: 'Descricao do perfil',
    activate: 'Ativar',
    deactivate: 'Desativar',
    notFound: 'Nenhum perfil encontrado.',
  },

  configuracao: {
    title: 'Configuracoes do Sistema',
    new: 'Nova Configuracao',
    edit: 'Editar Configuracao',
    chave: 'Chave',
    valor: 'Valor',
    descricao: 'Descricao',
    chavePlaceholder: 'Chave da configuracao',
    activate: 'Ativar',
    deactivate: 'Desativar',
    created: 'Configuracao criada com sucesso!',
    updated: 'Configuracao atualizada com sucesso!',
    deleted: 'Configuracao excluida com sucesso!',
    notFound: 'Nenhuma configuracao encontrada.',
  },

  auditoria: {
    title: 'Log de Auditoria',
    acao: 'Acao',
    entidade: 'Entidade',
    idEntidade: 'ID Entidade',
    usuario: 'Usuario',
    ip: 'IP',
    metodoHttp: 'Metodo HTTP',
    dataHora: 'Data/Hora',
    endpoint: 'Endpoint',
    detalhes: 'Detalhes',
    valoresAntigos: 'Valores Antigos',
    valoresNovos: 'Valores Novos',
    notFound: 'Nenhum registro de auditoria encontrado.',
    todasAcoes: 'Todas as acoes',
    dataInicio: 'Data Inicio',
    dataFim: 'Data Fim',
  },

  comissao: {
    title: 'Comissoes',
    calcular: 'Calcular',
    vendedorId: 'ID Vendedor (opcional)',
    dataInicio: 'Data Inicio',
    dataFim: 'Data Fim',
    totalVendido: 'Total Vendido',
    totalComissoes: 'Total Comissoes',
    qtdVendedores: 'Qtd Vendedores',
    vendedor: 'Vendedor',
    qtdVendas: 'Qtd Vendas',
    ticketMedio: 'Ticket Medio',
    percentComissao: '% Comissao',
    valorComissao: 'Valor Comissao',
    ranking: 'Ranking de Vendedores',
    vendas: 'vendas',
    notFound: 'Nenhuma comissao encontrada para o periodo.',
  },

  dashboard: {
    title: 'Dashboard',
    meuDia: 'Meu Dia',
    visaoGerencial: 'Visao Gerencial',
    controleEstoque: 'Controle de Estoque',
    administracao: 'Administracao do Sistema',
    indicadores: 'Indicadores em Tempo Real',
    statusCaixa: 'Status do Caixa',
    vendasHoje: 'Vendas Hoje',
    faturamentoHoje: 'Faturamento Hoje',
    saldoCaixa: 'Saldo do Caixa',
    vendasMes: 'Vendas no Mes',
    faturamentoMes: 'Faturamento Mes',
    ticketMedio: 'Ticket Medio',
    canceladasMes: 'Canceladas no Mes',
    produtosEstoque: 'Produtos em Estoque',
    abaixoMinimo: 'Abaixo do Minimo',
    estoqueZerado: 'Estoque Zerado',
    usuarios: 'Usuarios',
    logsAuditoria: 'Logs de Auditoria',
    errosRegistrados: 'Erros Registrados',
    configuracoes: 'Configuracoes',
    parcelasVencidas: 'Parcelas Vencidas',
    entregasPendentes: 'Entregas Pendentes',
    vendasPorFormaPagamento: 'Vendas por Forma de Pagamento (Mes)',
    acessoRapido: 'Acesso Rapido',
    irParaCaixa: 'Ir para Caixa',
    ultimasVendas: 'Ultimas Vendas',
    estoqueCritico: 'Estoque Critico',
    produtosEstoqueCritico: 'Produtos com Estoque Critico',
    ultimasAtividades: 'Ultimas Atividades',
    atividadePorTipo: 'Atividade por Tipo',
    vendasPorMes: 'Vendas por Mes',
    carregando: 'Carregando dashboard...',
    nenhumaVendaHoje: 'Nenhuma venda hoje',
    semDadosVendas: 'Sem dados de vendas',
    semDadosAuditoria: 'Sem dados de auditoria',
    nenhumaAtividade: 'Nenhuma atividade registrada',
    nenhumProdutoAbaixo: 'Nenhum produto abaixo do minimo',
  },

  greeting: {
    morning: 'Bom dia',
    afternoon: 'Boa tarde',
    evening: 'Boa noite',
  },

  theme: {
    light: 'Modo claro',
    dark: 'Modo escuro',
  },

  banhoTosa: {
    title: 'Banho e Tosa',
    new: 'Novo Agendamento',
    edit: 'Editar Agendamento',
    details: 'Detalhes do Agendamento',
    nomeAnimal: 'Nome do Animal',
    raca: 'Raca',
    porte: 'Porte',
    servico: 'Servico',
    observacoes: 'Observacoes',
    valor: 'Valor',
    dataAgendamento: 'Data Agendamento',
    clienteNome: 'Cliente',
    created: 'Agendamento criado com sucesso!',
    updated: 'Agendamento atualizado com sucesso!',
    deleted: 'Agendamento excluido com sucesso!',
    notFound: 'Nenhum agendamento de banho/tosa encontrado.',
    todosServicos: 'Todos os Servicos',
    banho: 'Banho',
    tosa: 'Tosa',
    banhoTosa: 'Banho + Tosa',
    clienteAgendamento: 'Cliente e Agendamento',
  },

  racoes: {
    title: 'Racoes e Acessorios',
    new: 'Novo Produto Pet',
    edit: 'Editar Produto Pet',
    details: 'Detalhes do Produto Pet',
    nome: 'Nome',
    marca: 'Marca',
    tipo: 'Tipo',
    animal: 'Animal',
    peso: 'Peso',
    preco: 'Preco',
    allTipos: 'Todos os Tipos',
    allAnimais: 'Todos os Animais',
    racao: 'Racao',
    acessorio: 'Acessorio',
    brinquedo: 'Brinquedo',
    higiene: 'Higiene',
    cao: 'Cao',
    gato: 'Gato',
    ave: 'Ave',
    peixe: 'Peixe',
    outro: 'Outro',
    created: 'Produto criado com sucesso!',
    updated: 'Produto atualizado com sucesso!',
    deleted: 'Produto excluido com sucesso!',
    notFound: 'Nenhum produto pet encontrado.',
  },

  cardapio: {
    title: 'Cardapio',
    new: 'Novo Item',
    edit: 'Editar Item',
    details: 'Detalhes do Item',
    nome: 'Nome',
    descricao: 'Descricao',
    categoria: 'Categoria',
    preco: 'Preco',
    disponivel: 'Disponivel',
    tempoPreparo: 'Tempo de Preparo',
    foto: 'Foto',
    created: 'Item criado com sucesso!',
    updated: 'Item atualizado com sucesso!',
    deleted: 'Item excluido com sucesso!',
    notFound: 'Nenhum item no cardapio encontrado.',
    todasCategorias: 'Todas as Categorias',
    disponiveis: 'Disponiveis',
    indisponiveis: 'Indisponiveis',
    entrada: 'Entrada',
    pratoPrincipal: 'Prato Principal',
    sobremesa: 'Sobremesa',
    bebida: 'Bebida',
    petisco: 'Petisco',
  },

  mesas: {
    title: 'Controle de Mesas',
    new: 'Nova Mesa',
    edit: 'Editar Mesa',
    details: 'Detalhes da Mesa',
    numero: 'Numero',
    capacidade: 'Capacidade',
    localizacao: 'Localizacao',
    observacoes: 'Observacoes',
    interna: 'Interna',
    externa: 'Externa',
    varanda: 'Varanda',
    allLocalizacoes: 'Todas as Localizacoes',
    allStatus: 'Todos os Status',
    qtdPessoas: 'Qtd pessoas',
    pessoas: 'pessoas',
    created: 'Mesa criada com sucesso!',
    updated: 'Mesa atualizada com sucesso!',
    deleted: 'Mesa excluida com sucesso!',
    notFound: 'Nenhuma mesa encontrada.',
  },

  prontuarios: {
    title: 'Prontuarios Veterinarios',
    new: 'Novo Prontuario',
    edit: 'Editar Prontuario',
    details: 'Detalhes do Prontuario',
    nomeAnimal: 'Nome do Animal',
    raca: 'Raca',
    especie: 'Especie',
    peso: 'Peso',
    idade: 'Idade',
    nomeProprietario: 'Proprietario',
    telefone: 'Telefone',
    historicoVacinas: 'Historico de Vacinas',
    alergias: 'Alergias',
    observacoes: 'Observacoes',
    dataUltimaConsulta: 'Data Ultima Consulta',
    created: 'Prontuario criado com sucesso!',
    updated: 'Prontuario atualizado com sucesso!',
    deleted: 'Prontuario excluido com sucesso!',
    notFound: 'Nenhum prontuario encontrado.',
    especieExemplo: 'Ex: Canino, Felino',
  },

  consultas: {
    title: 'Consultas Veterinarias',
    new: 'Nova Consulta',
    edit: 'Editar Consulta',
    details: 'Detalhes da Consulta',
    nomeAnimal: 'Animal',
    proprietario: 'Proprietario',
    veterinario: 'Veterinario',
    dataConsulta: 'Data da Consulta',
    motivo: 'Motivo',
    diagnostico: 'Diagnostico',
    prescricao: 'Prescricao',
    retorno: 'Retorno',
    valor: 'Valor',
    created: 'Consulta criada com sucesso!',
    updated: 'Consulta atualizada com sucesso!',
    deleted: 'Consulta excluida com sucesso!',
    notFound: 'Nenhuma consulta encontrada.',
  },

  agendamentos: {
    title: 'Agendamentos',
    new: 'Novo Agendamento',
    edit: 'Editar Agendamento',
    details: 'Detalhes do Agendamento',
    cliente: 'Cliente',
    servico: 'Servico',
    profissional: 'Profissional',
    dataHora: 'Data/Hora',
    duracao: 'Duracao',
    observacoes: 'Observacoes',
    valor: 'Valor',
    created: 'Agendamento criado com sucesso!',
    updated: 'Agendamento atualizado com sucesso!',
    deleted: 'Agendamento excluido com sucesso!',
    notFound: 'Nenhum agendamento encontrado.',
  },

  agendamento: {
    entityName: 'Agendamento',
    cliente: 'Cliente',
    buscarCliente: 'Buscar cliente...',
    profissional: 'Profissional',
    servico: 'Servico',
    horario: 'Horario',
    terminoEstimado: 'Termino Estimado',
    valorCobrado: 'Valor Cobrado (R$)',
    observacao: 'Observacao',
  },

  ordensServico: {
    title: 'Ordens de Servico',
    new: 'Nova Ordem de Servico',
    edit: 'Editar Ordem de Servico',
    details: 'Detalhes da Ordem de Servico',
    numero: 'Numero',
    cliente: 'Cliente',
    descricaoServico: 'Descricao do Servico',
    equipamento: 'Equipamento',
    marcaModelo: 'Marca/Modelo',
    defeito: 'Defeito',
    solucao: 'Solucao',
    pecasUsadas: 'Pecas Usadas',
    valorMaoDeObra: 'Valor Mao de Obra',
    valorPecas: 'Valor Pecas',
    valorTotal: 'Valor Total',
    dataEntrada: 'Data Entrada',
    dataSaida: 'Data Saida',
    created: 'Ordem de servico criada com sucesso!',
    updated: 'Ordem de servico atualizada com sucesso!',
    deleted: 'Ordem de servico excluida com sucesso!',
    notFound: 'Nenhuma ordem de servico encontrada.',
    numeroOS: 'Numero da OS',
    defeitoRelatado: 'Defeito Relatado',
    previsaoSaida: 'Previsao Saida',
    valoresDatas: 'Valores e Datas',
    valores: 'Valores',
  },

  permissao: {
    title: 'Permissoes Funcionais',
    salvarPermissoes: 'Salvar Permissoes',
    saved: 'Permissoes salvas com sucesso!',
    saveError: 'Erro ao salvar permissoes',
    adminAll: 'Administrador tem todas as permissoes',
    marcarTodas: 'Marcar Todas',
    desmarcarTodas: 'Desmarcar Todas',
    permissoesSelecionadas: 'permissao(oes) selecionada(s)',
    catVendas: 'Vendas',
    catCaixa: 'Caixa',
    catEstoque: 'Estoque',
    catProdutos: 'Produtos',
    catFinanceiro: 'Financeiro',
    catClientes: 'Clientes',
    catRelatorios: 'Relatorios',
    catTrocas: 'Trocas e Devolucoes',
    catDashboard: 'Dashboard (KPIs)',
    catAdmin: 'Administracao',
  },

  fidelidade: {
    title: 'Programa de Fidelidade',
    programa: 'Configuracao do Programa',
    ranking: 'Ranking de Pontos',
    historico: 'Historico de Pontos',
    pontos: 'Pontos',
    resgatar: 'Resgatar',
    cliente: 'Cliente',
    saldo: 'Saldo',
    notFound: 'Nenhum dado de fidelidade encontrado.',
    resgatarPontos: 'Resgatar Pontos',
    buscarClienteNome: 'Buscar cliente por nome...',
    pontosDisponiveis: 'Pontos Disponiveis',
    pontosParaResgatar: 'Pontos para Resgatar',
    quantidadePontos: 'Quantidade de pontos',
    minimoResgate: 'Minimo para resgate',
    motivoResgate: 'Motivo do resgate (opcional)',
    confirmarResgate: 'Confirmar Resgate',
    valorEmReais: 'Valor em R$',
    erroCarregarPontos: 'Erro ao carregar pontos do cliente',
    pontosResgatadosSucesso: '{pontos} pontos resgatados com sucesso!',
    erroResgatarPontos: 'Erro ao resgatar pontos',
    nomePrograma: 'Nome do Programa',
    pontosPerReal: 'Pontos por R$ gasto',
    valorPontosResgate: 'Valor de cada ponto no resgate (R$)',
    pontosAcumulados: 'Pontos Acumulados',
    pontosResgatados: 'Pontos Resgatados',
    ultimaMovimentacao: 'Ultima Movimentacao',
    tipo: 'Tipo',
    programaAtivo: 'Programa Ativo',
    programaInativo: 'Programa Inativo',
    salvarConfiguracao: 'Salvar Configuracao',
  },

  funcionario: {
    title: 'Controle de Funcionarios',
    new: 'Novo Funcionario',
    edit: 'Editar Funcionario',
    details: 'Detalhes do Funcionario',
    nome: 'Nome',
    cargo: 'Cargo',
    telefone: 'Telefone',
    email: 'Email',
    dataAdmissao: 'Data Admissao',
    comissao: '% Comissao',
    created: 'Funcionario criado com sucesso!',
    updated: 'Funcionario atualizado com sucesso!',
    deleted: 'Funcionario excluido com sucesso!',
    matricula: 'Matricula',
    departamento: 'Departamento',
    cpf: 'CPF',
    endereco: 'Endereco',
    observacao: 'Observacao',
    observacoes: 'Observacoes',
    usuarioVinculado: 'Usuario Vinculado',
    dadosProfissionais: 'Dados Profissionais',
    dadosPessoais: 'Dados Pessoais (LGPD)',
    vinculo: 'Vinculo',
    nomeCompleto: 'Nome completo',
    codigoInterno: 'Codigo interno',
    enderecoCompleto: 'Endereco completo',
    selecioneCargo: 'Selecione um cargo',
    selecioneDepartamento: 'Selecione um departamento',
    usuarioOpcional: 'Usuario (opcional)',
    selecioneUsuario: 'Selecione o usuario...',
    allCargos: 'Todos os Cargos',
    allDepartamentos: 'Todos os Departamentos',
    ativos: 'Ativos',
    inativos: 'Inativos',
    semVinculo: 'Sem vinculo',
    deactivate: 'Desativar',
    dataDemissao: 'Data Demissao',
    notFound: 'Nenhum funcionario encontrado.',
  },

  servico: {
    title: 'Controle de Servicos',
    new: 'Novo Servico',
    edit: 'Editar Servico',
    details: 'Detalhes do Servico',
    nome: 'Nome',
    descricao: 'Descricao',
    preco: 'Preco',
    duracao: 'Duracao',
    duracaoMinutos: 'Duracao (minutos)',
    categoria: 'Categoria',
    ativo: 'Ativo',
    selectCategoria: 'Selecione a categoria',
    allCategorias: 'Todas as Categorias',
    created: 'Servico criado com sucesso!',
    updated: 'Servico atualizado com sucesso!',
    deleted: 'Servico excluido com sucesso!',
    notFound: 'Nenhum servico encontrado.',
  },

  profissional: {
    title: 'Controle de Profissionais',
    new: 'Novo Profissional',
    edit: 'Editar Profissional',
    details: 'Detalhes do Profissional',
    nome: 'Nome',
    especialidade: 'Especialidade',
    telefone: 'Telefone',
    email: 'Email',
    comissao: 'Comissao (%)',
    ativo: 'Ativo',
    selectEspecialidade: 'Selecione a especialidade',
    created: 'Profissional criado com sucesso!',
    updated: 'Profissional atualizado com sucesso!',
    deleted: 'Profissional excluido com sucesso!',
    notFound: 'Nenhum profissional encontrado.',
  },

  receituario: {
    title: 'Receituarios',
    new: 'Novo Receituario',
    edit: 'Editar Receituario',
    cliente: 'Cliente',
    medico: 'Medico',
    crm: 'CRM',
    dataReceita: 'Data Receita',
    dataValidade: 'Data Validade',
    dadosGerais: 'Dados Gerais',
    selecioneCliente: 'Selecione o cliente...',
    nomeMedico: 'Nome do medico',
    olhoDireito: 'Olho Direito (OD)',
    olhoEsquerdo: 'Olho Esquerdo (OE)',
    esferico: 'Esferico',
    cilindrico: 'Cilindrico',
    eixo: 'Eixo',
    dnp: 'DNP',
    adicao: 'Adicao',
    lenteArmacao: 'Lente e Armacao',
    tipoLente: 'Tipo de Lente',
    materialLente: 'Material da Lente',
    material: 'Material',
    armacao: 'Armacao',
    descricaoArmacao: 'Descricao da armacao',
    observacoes: 'Observacoes',
  },

  exameOptometria: {
    title: 'Exames de Optometria',
    new: 'Novo Exame de Optometria',
    edit: 'Editar Exame de Optometria',
    cliente: 'Cliente',
    optometrista: 'Optometrista',
    nomeOptometrista: 'Nome do optometrista',
    registro: 'Registro',
    registroProfissional: 'Registro profissional',
    dataExame: 'Data do Exame',
    dadosExame: 'Dados do Exame',
    refracaoOD: 'Refracao - Olho Direito (OD)',
    refracaoOE: 'Refracao - Olho Esquerdo (OE)',
    acuidadeVisual: 'Acuidade Visual',
    odSemCorrecao: 'OD s/ Correcao',
    odComCorrecao: 'OD c/ Correcao',
    oeSemCorrecao: 'OE s/ Correcao',
    oeComCorrecao: 'OE c/ Correcao',
    pressaoIntraocular: 'Pressao Intraocular',
    pressaoOD: 'Pressao OD (mmHg)',
    pressaoOE: 'Pressao OE (mmHg)',
    informacoesAdicionais: 'Informacoes Adicionais',
    observacoes: 'Observacoes',
    encaminhamento: 'Encaminhamento',
  },

  pet: {
    title: 'Pets',
    new: 'Novo Pet',
    edit: 'Editar Pet',
    cliente: 'Cliente',
    nomeAnimal: 'Nome do Animal',
    dadosAnimal: 'Dados do Animal',
    especie: 'Especie',
    raca: 'Raca',
    cor: 'Cor',
    caracteristicas: 'Caracteristicas',
    porte: 'Porte',
    pesoKg: 'Peso (kg)',
    idade: 'Idade',
    idadeExemplo: 'Ex: 3 anos',
    sexo: 'Sexo',
    macho: 'Macho',
    femea: 'Femea',
    pequeno: 'Pequeno',
    medio: 'Medio',
    grande: 'Grande',
    castrado: 'Castrado',
    saude: 'Saude',
    alergias: 'Alergias',
    alergiasConhecidas: 'Alergias conhecidas',
    observacoes: 'Observacoes',
    observacoesGerais: 'Observacoes gerais',
  },

  segmentoDominio: {
    title: 'Segmentos',
    new: 'Novo Segmento',
    edit: 'Editar Segmento',
    icone: 'Icone',
    ordem: 'Ordem',
    informacoes: 'Informacoes do Segmento',
    nomePlaceholder: 'Nome do segmento',
    descricaoPlaceholder: 'Descricao do segmento',
    iconePlaceholder: 'Ex: fas fa-store',
    nomeObrigatorio: 'Nome e obrigatorio',
    created: 'Segmento criado com sucesso!',
    updated: 'Segmento atualizado com sucesso!',
    deleted: 'Segmento excluido com sucesso!',
    createError: 'Erro ao criar segmento',
    updateError: 'Erro ao atualizar segmento',
    deleteError: 'Erro ao excluir segmento',
  },

  planoDominio: {
    title: 'Planos',
    new: 'Novo Plano',
    edit: 'Editar Plano',
    preco: 'Preco',
    ordem: 'Ordem',
    informacoes: 'Informacoes do Plano',
    nomePlaceholder: 'Nome do plano',
    descricaoPlaceholder: 'Descricao do plano',
    nomeObrigatorio: 'Nome e obrigatorio',
    created: 'Plano criado com sucesso!',
    updated: 'Plano atualizado com sucesso!',
    deleted: 'Plano excluido com sucesso!',
    createError: 'Erro ao criar plano',
    updateError: 'Erro ao atualizar plano',
    deleteError: 'Erro ao excluir plano',
  },
  nfce: {
    title: 'NFC-e',
    numero: 'Numero',
    serie: 'Serie',
    venda: 'Venda',
    valorTotal: 'Valor Total',
    dataEmissao: 'Data Emissao',
    dataAutorizacao: 'Data Autorizacao',
    chaveAcesso: 'Chave de Acesso',
    protocolo: 'Protocolo',
    qrCode: 'QR Code',
    statusAutorizada: 'Autorizada',
    statusRejeitada: 'Rejeitada',
    statusPendente: 'Pendente',
    statusLocal: 'Local',
    statusCancelada: 'Cancelada',
    emitir: 'Emitir NFC-e',
    emitirTitle: 'Emitir NFC-e',
    selecionarVenda: 'Selecionar Venda',
    cancelar: 'Cancelar NFC-e',
    cancelarTitle: 'Cancelar NFC-e',
    cancelarAviso: 'Atencao: O cancelamento de uma NFC-e e irreversivel. Informe a justificativa abaixo.',
    justificativa: 'Justificativa',
    justificativaPlaceholder: 'Informe o motivo do cancelamento...',
    minCaracteres: 'minimo 15 caracteres',
    confirmarCancelamento: 'Confirmar Cancelamento',
    danfe: 'DANFE',
    dataInicio: 'Data Inicio',
    dataFim: 'Data Fim',
    emitidaSucesso: 'NFC-e emitida com sucesso!',
    canceladaSucesso: 'NFC-e cancelada com sucesso!',
    erroEmitir: 'Erro ao emitir NFC-e',
    erroCancelar: 'Erro ao cancelar NFC-e',
    erroDanfe: 'Erro ao baixar DANFE',
  },

  configuracaoFiscal: {
    title: 'Configuracao Fiscal',
    dadosFiscais: 'Dados Fiscais',
    dadosNfce: 'Dados NFC-e',
    opcoes: 'Opcoes',
    uf: 'UF',
    ambiente: 'Ambiente',
    homologacao: 'Homologacao',
    producao: 'Producao',
    modalidade: 'Modalidade',
    regimeTributario: 'Regime Tributario',
    simplesNacional: 'Simples Nacional',
    lucroPresumido: 'Lucro Presumido',
    lucroReal: 'Lucro Real',
    serieNfce: 'Serie NFC-e',
    ultimoNumeroNfce: 'Ultimo Numero NFC-e',
    inscricaoEstadual: 'Inscricao Estadual',
    csc: 'CSC (Codigo de Seguranca do Contribuinte)',
    cscId: 'CSC ID',
    emissaoAutomatica: 'Emissao Automatica',
    camposObrigatorios: 'Preencha todos os campos obrigatorios',
    cscObrigatorio: 'CSC e CSC ID sao obrigatorios para modalidade SEFAZ',
    salvoSucesso: 'Configuracao fiscal salva com sucesso!',
    erroSalvar: 'Erro ao salvar configuracao fiscal',
  },

  certificado: {
    title: 'Certificados Digitais',
    cnpj: 'CNPJ',
    validade: 'Validade',
    tipo: 'Tipo',
    arquivo: 'Arquivo',
    upload: 'Enviar Certificado',
    uploadTitle: 'Enviar Certificado Digital',
    arquivoPfx: 'Arquivo PFX/P12',
    senha: 'Senha do Certificado',
    senhaPlaceholder: 'Informe a senha do certificado',
    enviar: 'Enviar',
    desativar: 'Desativar',
    nenhumEncontrado: 'Nenhum certificado encontrado.',
    uploadSucesso: 'Certificado enviado com sucesso!',
    desativadoSucesso: 'Certificado desativado com sucesso!',
    erroUpload: 'Erro ao enviar certificado',
    erroDesativar: 'Erro ao desativar certificado',
  },

  lgpd: {
    title: 'Privacidade e Dados',
    politica: 'Politica de Privacidade',
    exportar: 'Exportar Meus Dados',
    excluir: 'Excluir Meus Dados',
    consentimento: 'Consentimento',
    consentimentoDados: 'Consentimento para processamento de dados',
    consentimentoMarketing: 'Consentimento para comunicacoes de marketing',
    salvarConsentimento: 'Salvar Consentimento',
    exportando: 'Exportando...',
    solicitarExclusao: 'Solicitar Exclusao',
    baixarJson: 'Baixar JSON',
  },

  pix: {
    pagarComPix: 'Pagar com PIX',
    valor: 'Valor',
    beneficiario: 'Beneficiario',
    chave: 'Chave PIX',
    copiaECola: 'PIX Copia e Cola',
    copiar: 'Copiar',
    copiado: 'Copiado!',
    instrucao: 'Abra o app do seu banco, escaneie o QR Code ou cole o codigo acima.',
    erroGerar: 'Nao foi possivel gerar o QR Code PIX.',
    configureChave: 'Configure a chave PIX em Administracao > Config. PIX.',
    configuracao: 'Configuracao PIX',
    chavePix: 'Chave PIX',
    tipoChave: 'Tipo de Chave',
    nomeBeneficiario: 'Nome do Beneficiario',
    cidadeBeneficiario: 'Cidade do Beneficiario',
    testar: 'Testar QR Code',
    salvar: 'Salvar Configuracao',
    tiposCpf: 'CPF',
    tiposCnpj: 'CNPJ',
    tiposEmail: 'E-mail',
    tiposTelefone: 'Telefone',
    tiposAleatoria: 'Chave Aleatoria',
  },
  multiLoja: {
    title: 'Dashboard Multi-Loja',
    vendasHoje: 'Vendas Hoje',
    faturamentoMes: 'Faturamento do Mes',
    estoqueCritico: 'Estoque Critico',
    parcelasVencidas: 'Parcelas Vencidas',
    comparativo: 'Comparativo por Loja',
    loja: 'Loja',
    segmento: 'Segmento',
    qtdVendas: 'Qtd. Vendas',
    parcelas: 'Parcelas',
    entregas: 'Entregas',
    verDetalhes: 'Ver Detalhes',
    todasAsLojas: 'Todas as Lojas',
  },
}
